"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSCVRIcon = void 0;
const React = __importStar(require("react"));
// import Icon from '@ant-design/icons';
const dscvr_logo_jpg_1 = __importDefault(require("./dscvr_logo.jpg"));
// @ts-ignore
// const IconSVG = () => <svg style={{width: 100, height: 100, transform: "scale(1.25)"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451.22 548.41">
//     <defs>
//         <clipPath id="clip-path" transform="translate(16.95 85.02)">
//             <path d="M116.58,348.88c-82.42-42.66-114-138.7-86.08-225.07a11.06,11.06,0,0,0-6.32-13.66l-1.61-.66L19.94,115q-4.38,9.14-7.84,18.68A202.88,202.88,0,0,0,135.86,394.12C183,403,228.8,401.19,264.07,383.07c36.23-18.62,61.6-54.36,85.32-101.43a166.46,166.46,0,0,1-28.91,38.8c-53.77,53.76-137.22,62.95-203.9,28.44Z" style={{fill: "none", clipRule: "evenodd"}}></path>
//         </clipPath>
//         <linearGradient id="linear-gradient" x1="95.35" y1="166.22" x2="309.52" y2="527.31" gradientUnits="userSpaceOnUse">
//             <stop offset="0.14" stopColor="#ffcd02"></stop>
//             <stop offset="0.37" stopColor="#ff963b"></stop>
//             <stop offset="0.7" stopColor="#ff6373"></stop>
//             <stop offset="1" stopColor="#ff4295"></stop>
//         </linearGradient>
//         <clipPath id="clip-path-2" transform="translate(16.95 85.02)">
//             <path d="M87.76,280.36c54.73,56.07,146.77,71.92,205.66,13,29.06-70.15,15.5-112.87-26.5-135.26a80.26,80.26,0,0,1,6.82,85.42c-30.44,58.23-117.72,55-160.1,11.64A131.09,131.09,0,0,1,77,177C64.13,103.42,93.17,45.84,163.54,4.32,108.75,16.69,68.07,55.1,48.07,111.88A167.85,167.85,0,0,0,87.76,280.36Z" style={{fill: "none", clipRule: "evenodd"}}></path>
//         </clipPath>
//         <linearGradient id="linear-gradient-2" x1="31.32" y1="96.9" x2="361.16" y2="426.74" gradientUnits="userSpaceOnUse">
//             <stop offset="0" stopColor="#1b59d2"></stop>
//             <stop offset="0.51" stopColor="#4e9bf2"></stop>
//             <stop offset="0.98" stopColor="#1b59d2"></stop>
//         </linearGradient>
//         <clipPath id="clip-path-3" transform="translate(16.95 85.02)">
//             <path d="M176.62,132.68c33.42-10.85,68.34-3.9,90.3,25.43q31.84,24.3,34.45,70.23,1.61,28.36-7.95,65a128.26,128.26,0,0,0,0-181.39C244,62.53,187.16,66.32,128.7,96.62l-3.6,1.87,3.05,93.38c4.57-13.69,15.1-14.75,22.92-24.49,8.18-10.17,13.82-28.84,25.55-34.7Z" style={{fill: "none", clipRule: "evenodd"}}></path>
//         </clipPath>
//         <linearGradient id="linear-gradient-3" x1="110.67" y1="185.5" x2="379.32" y2="340.61" gradientUnits="userSpaceOnUse">
//             <stop offset="0" stopColor="#50aff3"></stop>
//             <stop offset="0.33" stopColor="#4064c5"></stop>
//             <stop offset="1" stopColor="#6c349f"></stop>
//         </linearGradient>
//         <clipPath id="clip-path-4" transform="translate(16.95 85.02)">
//             <path d="M202.72,36.15A166.5,166.5,0,0,1,349.39,281.64Q279.17,421,135.86,394.12A202.75,202.75,0,1,0,209.33.06C207.12,0,204.91,0,202.7,0a180.58,180.58,0,0,0-39.16,4.32Q49.51,66.88,77,177A131.57,131.57,0,0,1,152.09,44l7.45-2.19a166.5,166.5,0,0,1,43.18-5.63Z" style={{fill: "none", clipRule: "evenodd"}}></path>
//         </clipPath>
//         <linearGradient id="linear-gradient-4" x1="167.99" y1="47.31" x2="342.99" y2="528.12" gradientUnits="userSpaceOnUse">
//             <stop offset="0" stopColor="#a700ba"></stop>
//             <stop offset="0.49" stopColor="#c00c95"></stop>
//             <stop offset="0.86" stopColor="#db1b62"></stop>
//         </linearGradient>
//         <clipPath id="clip-path-5" transform="translate(16.95 85.02)">
//             <path d="M178.85,273.3l-2.23-140.62a88.74,88.74,0,0,0-28.33,22.18q-12.84,15.15-20.14,37L130,248.4l1.87,1.81c15.27,14.8,31.71,19.8,47,23.09Z" style={{fill: "none", clipRule: "evenodd"}}></path>
//         </clipPath>
//         <linearGradient id="linear-gradient-5" x1="170.45" y1="215.97" x2="170.45" y2="360.05" gradientUnits="userSpaceOnUse">
//             <stop offset="0" stopColor="#1c58d2"></stop>
//             <stop offset="0.33" stopColor="#5734ca"></stop>
//             <stop offset="1" stopColor="#a203bc"></stop>
//         </linearGradient>
//     </defs>
//     <g id="Layer_2" data-name="Layer 2">
//         <g id="Layer_1-2" data-name="Layer 1">
//             <g style={{clipPath: "url('#clip-path')"}}>
//                 <rect x="12.27" y="188.8" width="376.62" height="309.68" style={{fill: "url('#linear-gradient')"}}></rect>
//                 <ellipse cx="219.85" cy="282.95" rx="192.05" ry="190.14" style={{opacity: "0.1"}}></ellipse>
//             </g>
//             <g style={{clipPath: "url('#clip-path-2')"}}>
//                 <rect x="50.15" y="78.08" width="292.19" height="367.49" style={{fill: "url('#linear-gradient-2')"}}></rect>
//                 <path d="M323.71,160c0,94.37-57.77,147.55-124.08,147.55-82.7,0-144.3-66.68-144.3-153S122.38-1.87,205.09-1.87,323.71,73.65,323.71,160Z" transform="translate(16.95 85.02)" style={{opacity: "0.1"}}></path>
//             </g>
//             <g style={{clipPath: "url('#clip-path-3')"}}>
//                 <rect x="134.89" y="143.55" width="220.21" height="239.01" style={{fill: "url('#linear-gradient-3')"}}></rect>
//                 <path d="M25.5-3V416.84H389.38V-3ZM197.63,338.56c-66.85,0-109-22.9-109-89.74,0-67.6,50.08-147.71,116.93-147.71,55.07,0,113.08,49.59,113.08,116.43A121,121,0,0,1,197.63,338.56Z" transform="translate(16.95 85.02)" style={{stroke: "rgb(0, 0, 0)", strokeMiterlimit: 10, strokeWidth: "0.01px", opacity: "0.1"}}></path>
//             </g>
//             <g style={{clipPath: "url('#clip-path-4')"}}>
//                 <rect x="80.1" y="79.3" width="350.78" height="416.84" style={{fill: "url('#linear-gradient-4')"}}></rect>
//                 <path d="M-16.95-85V463.38H434.26V-85ZM207.13,399.28c-99.81,0-180.72-86-180.72-192s80.91-192,180.72-192,180.71,86,180.71,192S306.93,399.28,207.13,399.28Z" transform="translate(16.95 85.02)" style={{stroke: "rgb(0, 0, 0)", strokeMiterlimit: 10, strokeWidth: "0.01px", fillRule: "evenodd", opacity: "0.1"}}></path>
//             </g>
//             <g style={{clipPath: "url('#clip-path-5')"}}>
//                 <rect x="142.72" y="215.97" width="55.47" height="144.08" style={{fill: "url('#linear-gradient-5')"}}></rect>
//                 <rect x="153.5" y="109.49" width="39.95" height="169.76" transform="matrix(1, -0.03, 0.03, 1, 11.68, 89.85)" style={{opacity: "0.1"}}></rect>
//             </g>
//         </g>
//     </g>
// </svg>
const DSCVRIcon = (props) => {
    // return <div style={{width: 100, height: 100, margin: "0 auto"}}><Icon component={IconSVG} {...props}/></div>
    return React.createElement("img", { src: dscvr_logo_jpg_1.default, style: { width: 100, height: 100, borderRadius: 100 } });
};
exports.DSCVRIcon = DSCVRIcon;
